import useGoogleOneTap from 'hooks/useGoogleOneTap'

const GoogleOneTap = () => {
  useGoogleOneTap()

  return null
}

export default GoogleOneTap
